import * as React from 'react'

import { SettingsPayrollEmployeeGroupEmployeeFragment } from 'generated/resources/graphql'

import BoxList from 'modules/core/components/BoxList'
import InlineSearch from 'modules/core/components/InlineSearch'

import { terminatedEmployee } from 'modules/settings/lib/terminatedEmployee'

import EmployeeListItem from './EmployeeListItem'

interface Props {
  search: string
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
  employees: SettingsPayrollEmployeeGroupEmployeeFragment[]
}

const EmployeeGroupSearchList = ({ search, onSearch, employees }: Props) => {
  return (
    <BoxList>
      <InlineSearch search={search} onSearch={onSearch} />
      {employees.map((employee) => {
        const isTerminatedEmployee = terminatedEmployee(employee)
        if (isTerminatedEmployee) return <></>
        return <EmployeeListItem employee={employee} key={employee.id} />
      })}
    </BoxList>
  )
}

export default EmployeeGroupSearchList
